import React from "react";
import AdSlot from "./AdSlot";

export default function BottomAd(props) {
  return <AdSlot id="ynpos-19121" {...props} />;
}
